import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Emitter } from 'vscode/vscode/vs/base/common/event';
import { IStorageService } from 'vscode/vscode/vs/platform/storage/common/storage.service';
import { isEmptyObject } from 'vscode/vscode/vs/base/common/types';

var SearchHistoryService_1;
let SearchHistoryService = class SearchHistoryService {
    static { SearchHistoryService_1 = this; }
    static { this.SEARCH_HISTORY_KEY = 'workbench.search.history'; }
    constructor(storageService) {
        this.storageService = storageService;
        this._onDidClearHistory = ( new Emitter());
        this.onDidClearHistory = this._onDidClearHistory.event;
    }
    clearHistory() {
        this.storageService.remove(SearchHistoryService_1.SEARCH_HISTORY_KEY, 1 );
        this._onDidClearHistory.fire();
    }
    load() {
        let result;
        const raw = this.storageService.get(SearchHistoryService_1.SEARCH_HISTORY_KEY, 1 );
        if (raw) {
            try {
                result = JSON.parse(raw);
            }
            catch (e) {
            }
        }
        return result || {};
    }
    save(history) {
        if (isEmptyObject(history)) {
            this.storageService.remove(SearchHistoryService_1.SEARCH_HISTORY_KEY, 1 );
        }
        else {
            this.storageService.store(SearchHistoryService_1.SEARCH_HISTORY_KEY, JSON.stringify(history), 1 , 0 );
        }
    }
};
SearchHistoryService = SearchHistoryService_1 = ( __decorate([
    ( __param(0, IStorageService))
], SearchHistoryService));

export { SearchHistoryService };
